<div class="analytical-method-info-container">
    <div class="analytical-method-details">
        <div class="form-row">
            <label for="analyticalMethodName">{{ 'Analytical Method Name' | translate }}:</label>
            <input id="analyticalMethodName" type="text" [value]="analyticalMethodDetails?.methodName || '-'"
                disabled />
        </div>
        <div class="form-row">
            <label for="associatedAgents">{{ 'Associated Agents' | translate }}:</label>
            <input id="associatedAgents" type="text" [value]="analyticalMethodDetails?.sampleMediaIds || '-'"
                disabled />
        </div>
    </div>
</div>

<div class="custom-theme-table px-3">
    <button class="add-media-btn btn" (click)="addSampleMedia()">{{ 'Add' | translate }}</button>
    <div class="table-responsive outer-bordered-table">
        <table mat-table [dataSource]="associatedMediaDataSource" matSort class="mat-elevation-z1">

            <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row': isLoading}">
                <td class="mat-cell text-center" [attr.colspan]="associatedMediaColumns.length">
                    @if (isLoading) {
                        <app-rings-loader class="bg-transparent"></app-rings-loader>
                    } @else {
                        {{"No data matching the filter" | translate}}
                    }
                </td>
            </tr>

            <ng-container matColumnDef="associatedMedia">
                <th class="left-aligned" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Associated Media' | translate }}</th>
                <td class="left-aligned" mat-cell *matCellDef="let element">{{ element || '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
                <td mat-cell *matCellDef="let element" class="text-align-right">
                    <span class="material-icons delete cursor-pointer material-grey-icon"
                        (click)="deleteSampleMedia(element)">delete</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="associatedMediaColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: associatedMediaColumns;" [class.even-row]="even">
            </tr>
        </table>
    </div>
    <div class="paginator-container">
        <span>{{ 'Displaying' | translate }}</span>
        <mat-paginator [length]="associatedMediaDataSource.data.length" [pageSizeOptions]="[5, 10, 20]" [pageSize]="10">
        </mat-paginator>
    </div>
</div>

<div class="custom-theme-table px-3">
    <div class="table-responsive outer-bordered-table">
        <table mat-table [dataSource]="agentJurisdictionDataSource" matSort class="mat-elevation-z1">

            <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row': isLoading}">
                <td class="mat-cell text-center" [attr.colspan]="agentJurisdictionColumns.length">
                    @if (isLoading) {
                        <app-rings-loader class="bg-transparent"></app-rings-loader>
                    } @else {
                        {{"No data matching the filter" | translate}}
                    }
                </td>
            </tr>

            <ng-container matColumnDef="name">
                <th class="left-aligned" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'Associated Jurisdiction Agent Combinations' | translate }}
                </th>
                <td class="left-aligned" mat-cell *matCellDef="let element">{{ element.name || '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
                <td mat-cell *matCellDef="let element" class="text-align-right">
                    <span class="material-icons edit cursor-pointer material-grey-icon"
                        (click)="agentJurisdictionDialog(element.id)">edit</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="agentJurisdictionColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: agentJurisdictionColumns;"
                [class.even-row]="even">
            </tr>
        </table>
    </div>
    <div class="paginator-container">
        <span>{{ 'Displaying' | translate }}</span>
        <mat-paginator [length]="agentJurisdictionDataSource.data.length" [pageSizeOptions]="[5, 10, 20]"
            [pageSize]="10">
        </mat-paginator>
    </div>
</div>